import MasterModule from './modules/MasterModule'
import LoginModule from './modules/LoginModule'
import UserManagementModule from './modules/UserManagementModule'
import ProjectManagementModule from './modules/ProjectManagementModule'
import NaiFlowModule from './modules/NaiFlowModule'
import ThemeModule from './modules/ThemeModule'
import WorkspaceModule from './modules/WorkspaceModule'
import StatisticsCaptureModule from './modules/StatisticsCaptureModule'
import DashboardModule from './modules/DashboardModule'
import RulesAndEscalationModule from './modules/RulesAndEscalationModule'
import QuizAssessmentModule from './modules/QuizAssessmentModule'
import VideoScriptGenerationModule from './modules/VideoScriptGenerationModule'

const api = {
  ...MasterModule,
  ...LoginModule,
  ...UserManagementModule,
  ...ProjectManagementModule,
  ...NaiFlowModule,
  ...ThemeModule,
  ...WorkspaceModule,
  ...StatisticsCaptureModule,
  ...DashboardModule,
  ...RulesAndEscalationModule,
  ...QuizAssessmentModule,
  ...VideoScriptGenerationModule,
}
export default api
